<template>
  <div>

  <v-container>
    <v-row class="d-flex justify-center align-center">
      <v-col class="d-flex justify-start" cols="12" sm="12" md="8" lg="8">
      </v-col>
      <v-col class="d-flex justify-center" cols="12" sm="12" md="8" lg="8">
        <div class="content" v-html="content"></div>
      </v-col>
      <v-col v-if="!content" class="d-flex flex-column justify-center align-center" cols="12" sm="12" md="8" lg="8">
        <v-img src="../../assets/Pulse-0.7s-200px.svg" max-width="50"></v-img>
        <h5 class="pa-0">Carregando...</h5> 
       </v-col>
    </v-row>
     <v-row class="d-flex justify-center align-center">
       <v-container class="d-flex justify-center align-center">
         <v-col class="d-flex justify-center pa-0 pt-10 pb-50" cols="12" sm="12" md="8" lg="8">
          <v-btn color="success" class="text-decoration-none" @click="back">Voltar</v-btn>
          </v-col>
        </v-container>
    </v-row>
    
  </v-container>
  <Footer/>
  </div>
</template>

<script>
import newsService from "../../service/newsService";
import covenantsService from "../../service/covenantsService";

export default {
  name: "PostCovenants",
  data() {
    return {
      content: ""
    };
  },
  methods: {
    getPost() {
      const paramsRouter = this.$router.history.current.params
      const id = parseInt(paramsRouter.id)
  
        covenantsService.get({id:id}).then(res => {
          const data = res.data[0];

          this.content = data.content;
        });  

},
    back(){
      this.$router.go(-1)
    }

  },
  components:{
    Footer:()=> import('../../layouts/web/commons/Footer')
  },
  mounted() {
    this.getPost();
  }
};
</script>

<style lang="scss" scoped>
.box-sizing {
  box-sizing: border-box;
}

// Coluna de leitura no mesmo padrão do post de notícia.
.content {
  max-width: 760px;
  margin: 0 auto;
  font-family: var(--font-text);
  font-size: 18px;
  line-height: 1.7;
  color: var(--c-ink);
  text-align: left;

  // O HTML do CMS entra por v-html, então precisa de ::v-deep para receber o estilo do escopo.
  ::v-deep h1,
  ::v-deep h2,
  ::v-deep h3 {
    font-family: var(--font-display);
    font-weight: 500;
    line-height: 1.2;
    color: var(--c-navy);
    text-align: left !important;
  }

  ::v-deep h1 {
    font-size: clamp(32px, 4vw, 44px);
    margin-bottom: 16px;
  }

  ::v-deep h2 {
    font-size: var(--fs-h3);
    font-weight: 500;
    color: var(--c-muted);
    margin-bottom: 20px;
  }

  ::v-deep p {
    text-align: left !important;
  }

  ::v-deep img {
    max-width: 100%;
    height: auto;
    border-radius: 6px;
  }
}
</style>

<style lang="sass">
  .img-post
    max-width: 100%
    background-position: center
    position: relative
    min-width: 100%
    max-width: 100%
    background-position: center
    max-height: 500px
</style>
